import "@/App.css";
import { ThemeProvider } from "@/components/sybrax/ThemeProvider";
import { LanguageProvider } from "@/components/sybrax/LanguageProvider";
import Navbar from "@/components/sybrax/Navbar";
import Hero from "@/components/sybrax/Hero";
import Stats from "@/components/sybrax/Stats";
import About from "@/components/sybrax/About";
import Products from "@/components/sybrax/Products";
import WhySybrax from "@/components/sybrax/WhySybrax";
import Roadmap from "@/components/sybrax/Roadmap";
import Team from "@/components/sybrax/Team";
import Contact from "@/components/sybrax/Contact";
import Footer from "@/components/sybrax/Footer";

function App() {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <div className="App relative min-h-screen bg-white text-slate-900 dark:bg-[#030712] dark:text-slate-50 antialiased transition-colors duration-300">
                    <Navbar />
                    <main data-testid="sybrax-main">
                        <Hero />
                        <Stats />
                        <About />
                        <Products />
                        <WhySybrax />
                        <Roadmap />
                        <Team />
                        <Contact />
                    </main>
                    <Footer />
                </div>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
